import { apiUrl } from './api_config'

const API_BASE_URL = apiUrl('/dashboard')
const DASHBOARD_ENDPOINT = `${API_BASE_URL}/data`

export async function getDashboardData({ role = '', userId = '' } = {}) {
  const params = new URLSearchParams()
  if (role) params.set('role', role)
  if (userId) params.set('user_id', String(userId))
  const query = params.toString()
  const response = await fetch(
    `${DASHBOARD_ENDPOINT}${query ? `?${query}` : ''}`,
    {
      headers: { 'Content-Type': 'application/json' },
    },
  )

  let payload = null
  try {
    payload = await response.json()
  } catch {
    // Preserve the HTTP error when the response has no JSON body.
  }

  if (!response.ok) {
    throw new Error(
      payload?.message ||
        payload?.error ||
        `Dashboard request failed (${response.status})`,
    )
  }

  return payload?.dashboard || payload?.data || payload
}
